import * as Sentry from '@sentry/browser'

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || ''

Sentry.init({
  dsn: SENTRY_DSN,
})

export default Sentry
